import React from 'react';

import ShadeSVG from './assets/shade-off.svg';

export const ShadeOff = () => (
  <div data-testid="shade-off">
    <img src={ShadeSVG} alt="" />
  </div>
);
